import * as t from "io-ts"

const VerticalType = t.union([t.literal(`Motor`), t.literal(`Drones`)])
export type Vertical = t.TypeOf<typeof VerticalType>
